<template>
  <div id="app">
    <div class="app-head" :class="{ is_fixed: isFixed }">
      <div class="app-head-top">
        <div class="h-t">
          <div class="h-t-left">
            <div class="phone">
              <img src="./images/d2.png" alt="" />
              <span>400-088-0777</span>
            </div>
            <div class="email">
              <img src="./images/y1.png" alt="" />
              <span>service_me@bioleaper.com</span>
            </div>
            <div></div>
          </div>
          <div class="h-t-right">
            <div></div>
            <div class="h-t-r-center">
              <div class="gowuche" @click="()=>{this.$router.push('/shopingCart')}">
                <img src="./images/gouwuche.png" alt="" />
                <div class="dot"></div>
                <span>购物车</span>
              </div>
              <div class="loginok" v-if="isLogin == true">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <i class="el-icon-user"></i><span class="personCenter">个人中心</span><i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/personalinfo')}">个人信息</span></el-dropdown-item>
                    <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/orderCenter')}">订单中心</span></el-dropdown-item>
                    <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/tryOrderCenter')}">试用订单</span></el-dropdown-item>
                    <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/orderCenter')}">物流查询</span></el-dropdown-item>
                    <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/addressManage')}">地址管理</span></el-dropdown-item>
                            <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/InvoiceControl')}">发票管理</span></el-dropdown-item>
                    <el-dropdown-item><span @click="()=>{this.$router.push('/personalCenter/balance')}">余额日志</span></el-dropdown-item>
                    <el-dropdown-item><span @click="quit">退出登录</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="btns" v-else>
                <img src="./images/btns.png" alt="" />
                <span class="login" @click="()=>{this.$router.push('/login')}">登录</span>
                <span class="register" @click="()=>{this.$router.push('/register')}">注册</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="app-head-bottom">
        <div class="a-h-b">
          <div class="h-b-img">
            <img @click="()=>{this.$router.push('/')}" src="./images/logo.png" alt="" />
          </div>
          <div class="a-h-nav">
            <nav class="h-b-nav">
              <ul class="nav-ul">
                <li class="nav-ul-li">
                   <router-link id ="nav" to="/">首页</router-link>
                </li>
                <li class="nav-ul-li">
                <router-link  target="_blank" id ="nav" to="/productCenter"> <p @mouseenter="mouseenterProduct">产品中心</p>  </router-link>
                  <dl class="productCenter" >
                      <dl v-for="(item,index) in classifyType" :key="index" class="one-level">
                        <li class="title">{{item.name}}</li>
                      <dl v-for="(i,v) in item.children" :key="v"
                        :class="i.id === currentIndex ? 'active' : ''"
                        style='font-weight:400'
                          @mouseenter="mouseOver(i.id)"
                          @mouseleave="mouseLeave(i.id)"
                          @click="pushurl(i.id)">
                        <li style="color:#666">{{i.name}}</li>
                      </dl>
                    </dl>
                  </dl>
                </li>
                <li class="nav-ul-li">
                  <router-link id ="nav" target="_blank" to="/technicalService"> <p @mouseenter="mouseenterServe">技术服务</p></router-link>
                  <ul class="one-level">
                    <li style='font-weight:400' v-for="(item,index) in serviceList" :key="index" @click="getServiceList(item.id)">{{item.name}}</li>
                  </ul>
                </li>
                <li class="nav-ul-li">
                  <router-link id ="nav" target="_blank" to="/technicalSupports">技术支持</router-link>
                  <ul class="one-level" style='font-weight:400'>
                    <li @click="()=>{this.$router.push('/technicalSupports/learningCenter')}">学习中心</li>
                    <!-- <li @click="()=>{this.$router.push('/technicalSupports/Download')}">说明书下载</li>
                    <li @click="()=>{this.$router.push('/technicalSupports/Inquire')}">MSDS/SDS查询</li> -->
                    <li @click="()=>{this.$router.push('/technicalSupports/coaInquire')}">COA查询</li>
                    <li @click="()=>{this.$router.push('/technicalSupports/experiment')}">实验委托书下载</li>
                  </ul>
                </li>
                <li class="nav-ul-li">
                  <router-link id ="nav" target="_blank" to="/html">客户服务</router-link>
                  <ul class="one-level" style='font-weight:400'>
                    <li @click="html('fukuan',7)">付款方式</li>
                    <li @click="html('peisong',8)">配送说明</li>
                    <li @click="html('fapiao',9)">发票说明</li>
                    <li @click="html('freight',10)">运输包装费说明</li>
                    <li @click="html('tuihuan',11)">退换政策</li>
                    <li @click="$router.push('/calculator')">科研工具</li>
                  </ul>
                </li>
               <li class="nav-ul-li">
                  <router-link id ="nav" target="_blank" to="/aboutUs">关于我们</router-link>
                  <ul class="one-level" style='font-weight:400'>
                    <li @click="()=>{this.$router.push('/aboutUs/companyProfile')}">走进百生跃</li>
                    <li @click="goMacklin()">走进麦克林</li>
                    <li @click="()=>{this.$router.push('/aboutUs/concatUs')}">联系我们</li>
                    <li @click="()=>{this.$router.push('/aboutUs/talentedPeople')}">诚聘英才</li>
                    <li @click="()=>{this.$router.push('/aboutUs/agentInvestment')}">代理招商</li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
          <div class="h-b-search">
            <Search></Search>
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex"
import Search from "./components/Search";
import request from "../src/utils/request"
export default {
  inject:['reload'],
  computed: {
    ...mapState(["isLogin",'serviceList','classifyType'])
  },
  data() {
    return {
      isFixed: false,
      offsetTop: 0,
      currentIndex:'',
      list:[]
    };
  },
  components: {
    Search,
  },
  mounted() {
    window.addEventListener("scroll", this.initHeight);
    this.$nextTick(() => {
      this.offsetTop = document.querySelector(".app-head").offsetTop;
    });
  },
  methods: {
    html(type,index){
      if(this.$route.path == '/html'){
        this.$router.push({path:"/html",query:{type:type,index:index}})
        this.$router.go(0)
      }else{
        this.$router.push({path:"/html",query:{type:type,index:index}})
      }
    },
    goMacklin(){
      window.open("http://www.macklin.cn/info/aboutus", '_blank');
    },
    mouseenterProduct(){
       this.$api.productCenter
      .getproduct({
        rank: 0,
      }).then(res=>{
        this.$store.state.classifyType = res.data
    })
    },
    ...mapActions(["setServeList"]),
    mouseenterServe(){
        this.setServeList()
    },
    getServiceList(id){
      if(this.$route.name == 'technicalService'){
        this.$router.push({path:'/technicalService',query:{id}})
        this.$router.go(0)
      }else{
        this.$router.push({path:'/technicalService',query:{id}})
      }
    },
    initHeight() {
       //获取顶端距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //滑动 大于顶端的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
    mouseOver(index) {
      this.currentIndex = index;
    },
    mouseLeave(index) {
      this.currentIndex = "";
    },
    pushurl(id){
      if(this.$route.name == 'productCenter'){
        this.$router.push({path:'/productCenter',query:{opennames:id}})
        this.$router.go(0)
      }else{
        this.$router.push({path:'/productCenter',query:{opennames:id}})
      }
    },
    quit(){
      localStorage.removeItem('token')
      localStorage.removeItem('Flag')
      sessionStorage.removeItem('value')
      this.$router.push('/')
      this.$router.go(0)
      this.$api.main.loginout({}).then(res=>{})
    }
  },
  //回调中移除监听
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less">
.app-head {
  width: 1920px;
  height: 144px;
  .app-head-top {
    width: 1920px;
    height: 44px;
    background: #b7b1b1;
    .h-t {
      width: 1510px;
      height: 44px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .h-t-left {
        display: flex;
        .phone,
        .email {
          display: flex;
          align-items: center;
          margin-right: 30px;
          span {
            height: 19px;
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            color: #003871;
            line-height: 19px;
          }
          img {
            width: 22px;
            height: 19px;
            margin-right: 10px;;
          }
        }
      }
      .h-t-right {
        .personCenter {
          color:#003871;
          font-weight: 700;
          font-size: 14px;
          margin-left: 6px;
        }
        .el-icon-user{
          color: #ffbb00;
          font-size: 19px !important;
        }
        .el-dropdown-link{
          display: flex;
          align-items: center;
          margin-top: 2px;
        }
        .h-t-r-center {
          display: flex;
          justify-content: space-around;
          .gowuche {
            display: flex;
            align-items: center;
            position: relative;
            span {
              cursor: pointer;
              width: 92px;
              height: 14px;
              font-size: 14px;
              font-weight: 700;
              color: #003871;
              margin-left: 10px;
              line-height: 14px;
            }
            img {
              width: 22px;
              height: 19px;
            }
            .dot {
              position: absolute;
              top: 11px;
              left: 18px;
              width: 7px;
              height: 7px;
              background: #ffbb00;
              border-radius: 50%;
            }
          }
          /deep/ .el-dropdown-link{
            cursor: pointer;
            .el-icon-user{
              font-size:16px;
              font-weight: 600;
              margin-left: 5px;
            }
          }
          .btns {
            position: relative;
            img {
              width: 121px;
              height: 40px;
            }
            .login {
              position: absolute;
              line-height: 44px;
              left: 25px;
              top: 0px;
              font-size: 14px;
              color: #002f60;
              cursor: pointer;
            }
            .register {
              position: absolute;
              line-height: 44px;
              right: 25px;
              top: 0px;
              font-size: 14px;
              color: #002f60;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .app-head-bottom {
    width: 100%;
    height: 100px;
    background: #003871;
    .a-h-b {
      width: 1510px;
      height: 100px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .h-b-img {
        text-align: center;
        width: 157px;
        height: 50px;
        cursor: pointer;
        img {
          width: 157px;
          height: 50px;
        }
      }
      .a-h-nav {
        flex: 1;
      }
      .h-b-nav {
        width: 80%;
        margin-left: 15%;
        display: flex;
        justify-content: space-around;
        .nav-ul{
          display:flex;
          font-weight: 600;
          .nav-ul-li{
            position:relative;
            height: 100px;
            padding: 0 20px;
            letter-spacing: 1px;
            a{
              display: block;
              height: 100%;
              font-size: 20px;
              line-height: 100px;
              color: white;
              p{
                width: 100%;
                height:100%
              }
            }
            a:hover{
              color:#ffbb00
            }
            .router-link-exact-active{
              color: #ffbb00;
            }
            ul{
              display:none;
              position:absolute;
              top:100px;
              left:0px;
              z-index:3
            }
            .productCenter{
              display:none;
              position:absolute;
              top:100px;
              left:0px;
              z-index:3;
              dl{
                width:160px;
              }
            }
            .one-level{
              width:160px;
              li{
                font-size: 16px;
                text-align: left;
                margin: 5px 10px;
                cursor: pointer;
              }
            }
          }
          .nav-ul-li:hover{
            ul{
              display:block;
              background:white;
              border:1px solid #eee;
              border-top:none;
              box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
              animation: upin 0.3s ease-in forwards;
              li:hover{
                color:#A52A2A !important;
              }
              li{
                color:#666 !important
              }
            }
            .productCenter{
              display:block;
              background:white;
              border:1px solid #eee;
              border-top:none;
              box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
              animation: upin 0.3s ease-in forwards;
              display: flex;
              justify-content: space-around;
              letter-spacing: 1px;
              .title{
                font-weight: 600;
                color:#666
              }
              .active{
                li{
                   color:#A52A2A !important;
                }
                color:#A52A2A !important;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
}
.is_fixed {
  position: fixed;
  top: 0;
  z-index: 999;
}
@keyframes reback {
  from {
    position: fixed;
    top: -200px;
  }
  to {
    position: fixed;
    top: 0px;
  }
}
@keyframes upin{
    0% {
        opacity: 0;
        transform: translateY(-10%)
    }
    100% {
        opacity: 1;
        transform: translateY(0)
    }
}
</style>
